define(function(require){
    'use strict';

    var Marionette  = require('marionette');
    var StaffSelect = require('popovers/staff_select/view');
    var BodyView    = require('popovers/staff_call_to_contact/view/body');
    var StaffCollection    = require('collections/staffs');

    return StaffSelect.extend({
        //initialize: function(options) {
        //    BasePopover.prototype.initialize.call(this, options);
        //    this.staffCollection = new StaffCollection();
        //    this.listenTo(this.staffCollection, 'sync', this.render);
        //    this.staffCollection.fetch();
        //},
        /*
        *   function onBeforeRender()
        *   Event onBeforeRender
        */
        //onBeforeRender : function(){
        //    this.model.set({
        //        'placement' : "bottom" ,
        //        'show_footer' : false ,
        //        'show_header' : false ,
        //        'width'     : '250px',
        //        'height'    : '300px'
        //    });
        //},

        /*
        *   function showBody()
        *   Show body
        */
        showBody: function(){
            var body = new BodyView({ model: this.model, collection: this.staffCollection});
            this.regionBody.show(body);

            this.$('.popover-body').scrollbar();

            $('.js-table-parent.scroll-content, .b-card__fields').scroll(function () {
                app.Vents.trigger('datatable:scroll');
            });
        },

        // View ui elements
        ui: {
            call : '.js-call'
        },

        // View events
        events : {
            'click @ui.call' : 'call'
        } ,

        /*
        *   function changeLink()
        *   Change phone site_id
        *   @param  {event} event
        */
        call: function(event){
            var target  = $(event.currentTarget);
            var data    = target.data();
            var obj = {
                employee: this.staffCollection.get(data.id),
                type: data.type
            };
            // Hide popover
            this.hide();
            this.trigger('employee:selected', obj);
        }
    });

 });
